import "core-js/modules/es.array.includes.js";
function getContentProgress(_ref) {
  var _ref$isPlaylist = _ref.isPlaylist,
    isPlaylist = _ref$isPlaylist === void 0 ? false : _ref$isPlaylist,
    userContentStatus = _ref.userContentStatus,
    userScormAssetStatus = _ref.userScormAssetStatus,
    _ref$completionRate = _ref.completionRate,
    completionRate = _ref$completionRate === void 0 ? 0 : _ref$completionRate;
  // Handle playlist progress
  if (isPlaylist) {
    return {
      status: userContentStatus,
      value: completionRate
    };
  }

  // Handle asset progress
  var progressStatus = userContentStatus === 'opened' && userScormAssetStatus === 'failed' ? 'failed' : userContentStatus;

  // Set value as we have no granular completionRate for assets
  var value;
  if (progressStatus && ['failed', 'opened'].includes(progressStatus)) {
    value = 0;
  }
  if (progressStatus === 'completed') {
    value = 1;
  } else {
    value = completionRate;
  }
  return {
    value: value,
    status: progressStatus || 'notstarted'
  };
}
export default getContentProgress;